import { useState } from 'react';
import { Form, Input, Button, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import { authApi } from '../api/auth';
import { useAuthStore } from '../stores/authStore';
import { AuthKart } from '../components/AuthKart';

export function Login() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const login = useAuthStore((state) => state.login);

  const onFinish = async (values: { email: string; password: string }) => {
    setLoading(true);
    try {
      const response = await authApi.login(values.email, values.password);
      login(response.token, response.user);
      message.success('Giriş başarılı');
      navigate('/');
    } catch (error: any) {
      // Backend returns specific error message for unauthorized users
      const errorMessage = error.response?.data?.message || 'E-posta veya şifre hatalı';
      message.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthKart>
      <Form
        name="login"
        onFinish={onFinish}
        layout="vertical"
        size="large"
      >
        <Form.Item
          name="email"
          rules={[
            { required: true, message: 'E-posta gerekli' },
            { type: 'email', message: 'Geçerli bir e-posta girin' }
          ]}
        >
          <Input
            prefix={<UserOutlined />}
            placeholder="E-posta"
          />
        </Form.Item>

        <Form.Item
          name="password"
          rules={[{ required: true, message: 'Şifre gerekli' }]}
        >
          <Input.Password
            prefix={<LockOutlined />}
            placeholder="Şifre"
          />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            block
          >
            Giriş Yap
          </Button>
        </Form.Item>
      </Form>

      <div style={{ textAlign: 'center' }}>
        <Link to="/sifremi-unuttum" style={{ color: 'rgba(0,0,0,0.45)', fontSize: 13 }}>
          Şifremi unuttum
        </Link>
      </div>
    </AuthKart>
  );
}
